// @flow
import * as React from 'react';
import styled from 'styled-components';
import default_image from '../../assets/images/LeagueAvatar.svg';
const LEAGUE_AVATARS_PATH = process.env.REACT_APP_LEAGUE_AVATARS_PATH || '';


const LeagueAvatarWrapper = styled.div`
	border-radius: 50%;
	overflow: hidden;
`;

const LeagueAvatarPicture = styled.picture`
	display: block;
	img {
		display: block;
		height: ${({ size }) => size || '100%'};
		width: ${({ size }) => size || '100%'};
		object-fit: cover;
	}
`;

type Props = {
	league: {
		id: number,
		avatar_version: number,
		is_club?: boolean,
		name: string
	},
	size?: string,
	className?: string,
};

export const LeagueAvatar = ({ league, size, className }: Props) => {
	const { id, avatar_version, is_club, name } = league,
		avatar = `${LEAGUE_AVATARS_PATH}${id}.png?v=${avatar_version}`,
		is_avatar = is_club || avatar_version
		;

	return (
		<LeagueAvatarWrapper className={className}>
			<LeagueAvatarPicture size={size}>
				{is_avatar ? <source srcSet={avatar} type="image/png" /> : null}
				<img src={default_image} alt={name} />
			</LeagueAvatarPicture>
		</LeagueAvatarWrapper>
	);
};

export default LeagueAvatar;


// WEBPACK FOOTER //
// ./src/components/Leagues/LeagueAvatar.js